var API_URL = `${process.env.REACT_APP_API_BASE_URL}/api/`;

export { API_URL };
